import React from 'react';
import { useSelector } from 'react-redux';

import BannerCarousel from '../BannerCarousel';
import PowerPerksBanner from '.';

const PowerPerksBannerCarousel = () => {
    const prismic = useSelector(({ prismic }) => prismic);
    // eslint-disable-next-line camelcase
    const { power_perks } = prismic;

    if (power_perks?.perks_banner) {
        return (
            <BannerCarousel>
                {power_perks.perks_banner?.[0]?.repeatable?.map((banner) => <PowerPerksBanner key={banner.banner_id} banner={banner} />)}
            </BannerCarousel>
        );
    }
    return null;
};

export default PowerPerksBannerCarousel;
